import React, { createContext, useContext, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { WB_PREVIEW_PREFIX } from './wbPaths';

const WbRouteContext = createContext({ routePrefix: '', isPreview: false });

export function WbRouteProvider({ children, routePrefix = WB_PREVIEW_PREFIX }) {
  const value = useMemo(
    () => ({ routePrefix, isPreview: routePrefix === WB_PREVIEW_PREFIX }),
    [routePrefix]
  );
  return <WbRouteContext.Provider value={value}>{children}</WbRouteContext.Provider>;
}

export function useWbRoute() {
  return useContext(WbRouteContext);
}

export function useWbPath() {
  const { routePrefix } = useWbRoute();

  return useCallback(
    (path) => {
      const normalized = path.startsWith('/') ? path : `/${path}`;
      return routePrefix ? `${routePrefix}${normalized}` : normalized;
    },
    [routePrefix]
  );
}

export function useWbNavigate() {
  const navigate = useNavigate();
  const toPath = useWbPath();

  return useCallback(
    (path, options) => {
      navigate(toPath(path), options);
    },
    [navigate, toPath]
  );
}
